import * as React from 'react';
export var NaviContext = React.createContext({});
export var NavConsumer = NaviContext.Consumer;
export var NavContextProvider = NaviContext.Provider;
//# sourceMappingURL=NaviContext.js.map